var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:_vm.loadingClasses,style:({'min-height': _vm.minHeight ? (_vm.minHeight + "px") : null})},[_c('div',{staticClass:"loader__content"},[_c('div',{staticClass:"loader__spinner"}),_vm._v(" "),(_vm.message)?_c('p',{staticClass:"loader__message",domProps:{"textContent":_vm._s(_vm.message)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb06c13","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/LoadingSpinner.vue
// module id = null
// module chunks = 